/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

function isAdd(newRequest) {
    return newRequest && newRequest.quantity === 1;
}

function hasOldRequest(oldRequest) {
    return oldRequest !== null;
}

function isNewAdd(oldRequest, newRequest) {
    return !hasOldRequest(oldRequest) && isAdd(newRequest);
}

function isQuantityDifferent(oldRequest, newRequest) {
    return oldRequest.quantity !== newRequest.quantity;
}

function isAddAndDataChanges(oldRequest, newRequest) {
    return isAdd(newRequest) && !Odigeo._.isEqual(Odigeo._.omit(oldRequest, 'password'), Odigeo._.omit(newRequest, 'password'));
}

function needsUpdate(oldRequest, newRequest) {
    return isQuantityDifferent(oldRequest, newRequest) || isAddAndDataChanges(oldRequest, newRequest);
}

function hasOldRequestAndNeedsUpdate(oldRequest, newRequest) {
    return hasOldRequest(oldRequest) && needsUpdate(oldRequest, newRequest);
}

module.exports = {
    getUrl: function() {
        return 'updatemembershipproduct';
    },

    getMethod: function() {
        return 'POST';
    },
    requestSuccess: function(response) {
        if (Odigeo._.isEmpty(response)) {
            Odigeo.Session.remove('newMembershipProduct');
            Odigeo.trigger(this.widget.id + ':addMembershipOk', response);
        } else {
            Odigeo.trigger(this.widget.id + ':addMembershipFailRetry', response);
        }
        // storage to resend in case of error, removed after retry user decision
        Odigeo.Session.set('membershipProductPreviousRequest', JSON.stringify(this.get('request')));
    },

    requestError: function(response) {
        Odigeo.trigger(this.widget.id + ':addMembershipFailRetry');
    },

    requestComplete: function() {
        Odigeo.trigger(this.widget.id + ':addMembershipComplete');
    },

    formatData: function(request) {
        return JSON.stringify({
            email: request.email,
            password: request.password,
            quantity: request.quantity,
            name: request.name,
            lastNames: request.lastName,
            operation: request.operation ? request.operation : null,
        });
    },

    hasToPerformRequest: function(newRequest) {
        const oldRequest = Odigeo.Utils.parseJson(Odigeo.Session.get('membershipProductPreviousRequest'));
        const isUserMembershipAddedSession = Odigeo.Utils.parseJson(Odigeo.Session.get('isUserSubscribedItem')) ||
        Odigeo.Utils.parseJson(Odigeo.Session.get('isUserSubscribedItem'));
        const isMembershipNotAdded = Odigeo._.get(oldRequest, 'quantity') === 0;
        const errorHappened = isMembershipNotAdded === !isUserMembershipAddedSession;
        return isNewAdd(oldRequest, newRequest) || hasOldRequestAndNeedsUpdate(oldRequest, newRequest)
            || errorHappened;
    },

    clearMembershipSessionValues: function() {
        Odigeo.Session.remove('membershipProductPreviousRequest');
        Odigeo.Session.remove('newMembershipProduct');
        Odigeo.Session.remove('membershipSubscriptionPriceItem');
        Odigeo.Session.remove('isMemberRenewalCanceledItem');
        Odigeo.Session.remove('isUserSubscribedItem');
    },

    updateMembershipProduct: function(membershipProduct) {
        const newMembershipProduct = JSON.stringify(membershipProduct);
        Odigeo.Session.set('newMembershipProduct', newMembershipProduct);
    },
};
